// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"601c76e8","455":"3900e2fc","762":"b8000c5d","977":"dbf7319f"}[chunkId] + ".chunk.js";
};